import { render, staticRenderFns } from "./profile-container.vue?vue&type=template&id=1485a77e&scoped=true&lang=pug"
import script from "./profile-container.js?vue&type=script&lang=js&external"
export * from "./profile-container.js?vue&type=script&lang=js&external"
import style0 from "./profile-container.vue?vue&type=style&index=0&id=1485a77e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485a77e",
  null
  
)

export default component.exports